import {
  patchState,
  signalStoreFeature,
  type,
  withMethods,
} from '@ngrx/signals';
import {
  entityConfig,
  setAllEntities,
  withEntities,
} from '@ngrx/signals/entities';

import { OrganizationFacilities } from '../../types';

const _organizationFacilitiesEntityConfig = () =>
  entityConfig({
    collection: '_facilities',
    entity: type<OrganizationFacilities>(),
    selectId: (entity) => entity.id,
  });

export const withOrganizationFacilitiesEntities = () => {
  return signalStoreFeature(
    withEntities(_organizationFacilitiesEntityConfig()),
    withMethods(({ ...store }) => ({
      loadFacilities: (data: OrganizationFacilities[]) => {
        return patchState(
          store,
          setAllEntities(data, _organizationFacilitiesEntityConfig()),
        );
      },
    })),
  );
};
